<div class="dialog-content">
  <div>
    <div class="dialog-header">
      <div class="dialog-header-text">Media assets library</div>
      <div class="cross-icon" (click)="onCancel()">
        <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
      </div>
    </div>
    <div class="secondary-text">Select an image to assign to this Event Type.</div>
  </div>

  <div class="content">
    <div class="loading-container" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading images...</p>
    </div>

    <div>
      <div class="media-grid" *ngIf="!isLoading && mediaItems.length > 0">
        <div 
          class="media-item" 
          *ngFor="let item of mediaItems"
          [class.selected]="selectedImageId === item.id"
          [class.not-selected]="selectedImageId && selectedImageId !== item.id"
          (click)="toggleSelection(item)"
        >
          <div class="image-container">
            <img 
              [src]="item.imagePath" 
              [alt]="'Media image ' + item.id"
              loading="lazy"
              (error)="handleImageError($event)"
            >
            
            <!-- Selected Checkbox Overlay -->
            <div class="checkbox-overlay" *ngIf="selectedImageId === item.id">
              <div class="checkbox checked">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5 4.5L6.5 11.5L2.5 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Show empty checkbox for unselected items -->
            <div class="checkbox-overlay" *ngIf="!selectedImageId || (selectedImageId && selectedImageId !== item.id)">
              <div class="checkbox"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-results" *ngIf="!isLoading && mediaItems.length === 0">
      <p>No media assets found</p>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="btn-secondary" (click)="onCancel()">Cancel</button>
    <button 
      class="btn-primary" 
      [disabled]="!selectedImageId"
      (click)="onSelect()"
    >
      Select Image
    </button>
  </div>
</div>